const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'personalCenter',
        component: () => import(/* webpackChunkName: "b2b_personal" */ '@/pages/personalCenter'),
        meta: {
          title: '个人中心'
        },
        path: '/personalCenter',
        children: [
          {
            name: 'index',
            component: () => import(/* webpackChunkName: "b2b_personal_index" */ '@/pages/personalCenter/home'),
            meta: {
              title: '首页',
              sidebar: 'index'
            },
            path: 'index'
          },
          {
            name: 'address',
            component: () => import(/* webpackChunkName: "b2b_personal_address" */ '@/pages/personalCenter/address'),
            meta: {
              title: '收货地址',
              sidebar: 'address'
            },
            path: 'address'
          },
          {
            name: 'invoice',
            component: () => import(/* webpackChunkName: "b2b_personal_invoice" */ '@/pages/personalCenter/invoice'),
            meta: {
              title: '开票信息',
              sidebar: 'invoice'
            },
            path: 'invoice'
          },
          {
            name: 'qualification',
            component: () =>
              import(/* webpackChunkName: "b2b_personal_qualification" */ '@/pages/personalCenter/qualification'),
            meta: {
              title: '我的资质',
              sidebar: 'qualification'
            },
            path: 'qualification'
          },
          {
            name: 'password',
            component: () => import(/* webpackChunkName: "b2b_personal_password" */ '@/pages/personalCenter/password'),
            meta: {
              title: '密码修改',
              sidebar: 'password'
            },
            path: 'password'
          },
          {
            name: 'phone',
            component: () => import(/* webpackChunkName: "b2b_personal_phone" */ '@/pages/personalCenter/phone'),
            meta: {
              title: '修改手机号',
              sidebar: 'phone'
            },
            path: 'phone'
          },
          {
            name: 'coupon',
            component: () => import(/* webpackChunkName: "b2b_personal" */ '@/pages/personalCenter/coupon'),
            meta: {
              title: '我的优惠券',
              sidebar: 'coupon'
            },
            path: 'coupon'
          },
          {
            name: 'agreement',
            component: () => import(/* webpackChunkName: "b2b_personal" */ '@/pages/personalCenter/agreement'),
            meta: {
              title: '资质与协议',
              sidebar: 'agreement'
            },
            path: 'agreement'
          }
        ]
      }
    ]
  }
];
